var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"size":_vm.size,"title":"중대시민재해 대상 시설 현황","value":_vm.data,"unit":"개소","isMoveWrite":_vm.isMoveWrite,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite,"item":_vm.onClickItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }